import React from "react";
import SectionHeaders from "../ui/SectionHeaders";
import StaticContent from "../ui/StaticContent";
import { useState } from "react";
import Dialog from "@components/Dialog";

import NearestRetailer from "../ui/NearestRetailer";
import Modal from "@components/Modal";

const HomePageContentSection = ({ section_data }) => {
  const [openVisit, setOpenVisit] = useState(false);

  const handleToggleOpenVisit = () => setOpenVisit((prev) => !prev);

  if (section_data) {
    if (section_data?.content_section?.key !== "contact") {
      return (
        <div
          className={`${section_data.layout_class || "container mx-auto"} my-4`}
        >
          <div className={`${section_data.custom_class}`}>
            {section_data.is_header && (
              <SectionHeaders
                title={section_data.name || section_data.content_section?.name}
              />
            )}
            {section_data.content_section?.description && (
              <StaticContent
                description={section_data.content_section.description}
              />
            )}
          </div>
        </div>
      );
    } else {
      return (
        <>
          <div
            className={`${
              section_data.layout_class || "container mx-auto"
            } my-4 flex justify-center`}
          >
            <div className={`${section_data.custom_class}`}>
              {section_data.is_header && (
                <SectionHeaders
                  title={
                    section_data.name || section_data.content_section?.name
                  }
                />
              )}
              {section_data.content_section?.description && (
                <div onClick={handleToggleOpenVisit}>
                  <StaticContent
                    description={section_data.content_section.description}
                  />
                </div>
              )}
            </div>
          </div>
          <Modal
            title='Search retailer nearest to your location.'
            opened={openVisit}
            onClose={handleToggleOpenVisit}
            className='w-4/5 md:w-3/4 lg:w-1/2'
          >
            <NearestRetailer />
          </Modal>
        </>
      );
    }
  }
  return <></>;
};

export default HomePageContentSection;
